import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  REPORTED_INCIDENTS_CLEAR,
  REPORTED_INCIDENTS_FETCH_DISCARD_REASONS,
} from '../../../actions/actionTypes';

const discardReasons = fetchReducerGenerator(
  REPORTED_INCIDENTS_CLEAR,
  REPORTED_INCIDENTS_FETCH_DISCARD_REASONS
);

export default discardReasons;
